<template>
  <div
    class="mb-4 flex w-full flex-row items-baseline justify-between gap-4 border-b border-t border-gray-700 px-4 py-3"
  >
    <div class="flex flex-row">
      <p class="text-[10px] font-semibold text-gray-400">TRANS.:&nbsp;</p>
      <p v-if="receipts[0]" class="text-[10px] font-semibold text-white">
        {{ receipts[0].carrier }}
      </p>
    </div>
    <div class="flex flex-row">
      <p class="text-[10px] font-semibold text-gray-400">DATA:&nbsp;</p>
      <p v-if="receipts[0]" class="text-[10px] font-semibold text-white">
        {{ receipts[0].invoiceDate ? datetime.format(receipts[0].invoiceDate, 'dd/MM/yyyy') : '-' }}
      </p>
    </div>
  </div>

  <div
    v-for="(receipt, index) in sortedReceipts"
    :key="index"
    class="flex w-full items-center justify-between py-2"
  >
    <ReceiptInfo
      :details="receipt"
      :is-collapsed="selectedShippingReceipt?.id === receipt.id"
      @init-check="(barCode) => onScanShippingReceipt(barCode)"
      :selected-product-id="selectedProductId ?? undefined"
    ></ReceiptInfo>
  </div>
</template>

<script setup lang="ts">
import ReceiptInfo, { type ReceiptDetailsProps } from '@/components/ReceiptInfo/ReceiptInfo.vue'
import { ShippingReceiptStatus } from '@/services/WarrantyApiService/types'
import { useDateTime } from '@/value-objects/date-time'
import { computed, onMounted, onUnmounted } from 'vue'
import { useBarCodeReader } from './hooks/useBarCodeReader'

const datetime = useDateTime()
interface ReceiptDeatilsCardProps {
  receipts: ReceiptDetailsProps[]
  shippingId: string
  callback?: () => Promise<unknown>
}

const props = defineProps<ReceiptDeatilsCardProps>()

const emit = defineEmits(['update-receipts'])

const computedReceipts = computed(() => {
  return props.receipts
})

const {
  selectedShippingReceipt,
  selectedProductId,
  onScanShippingReceipt,
  startListening,
  stopListening
} = useBarCodeReader(computedReceipts, props.shippingId, emit)

const selectedReceipt = computed(() => {
  return props.receipts.find((receipt) => receipt.id === selectedShippingReceipt.value?.id)
})

const sortedReceipts = computed(() => {
  const otherReceipts = props.receipts.filter((receipt) => receipt.id !== selectedReceipt.value?.id)

  otherReceipts.sort((a, b) => {
    const isACompleted = a.status === ShippingReceiptStatus.COMPLETED
    const isBCompleted = b.status === ShippingReceiptStatus.COMPLETED

    if (!isACompleted && isBCompleted) return -1
    if (isACompleted && !isBCompleted) return 1

    return 0
  })

  return selectedReceipt.value ? [selectedReceipt.value, ...otherReceipts] : otherReceipts
})

onMounted(() => {
  startListening()
})

onUnmounted(() => {
  stopListening()
})
</script>
